<template>
  <el-upload
    ref="filesUpload"
    :data="{ associationId }"
    :headers="{ Authorization: getAuthHeader() }"
    :auto-upload="false"
    :on-success="onUploadSuccess"
    :action="getSupportAttachUrl()"
    multiple>
    <el-button
      size="medium"
      icon="el-icon-paperclip"
      type="primary">
      Прикрепить
    </el-button>
  </el-upload>
</template>

<script>
  import { getAuthHeader, getSupportAttachUrl } from '@/utils'

  export default {
    data() {
      return {
        associationId: null,
        filesCount: 0
      }
    },

    methods: {
      getAuthHeader,
      getSupportAttachUrl,

      startUploading(associationId) {
        this.associationId = associationId
        this.filesCount = this.$refs.filesUpload.uploadFiles.length

        if (!this.filesCount) {
          this.$emit('upload-complete')
        } else {
          this.$nextTick(() => {
            console.log(this.associationId)
            console.log(this.$refs.filesUpload.data)
            this.$refs.filesUpload.submit()
          })
        }
      },

      onUploadSuccess() {
        this.filesCount -= 1

        if (this.filesCount === 0) {
          this.$refs.filesUpload.clearFiles()
          this.$emit('upload-complete')
        }
      }
    }
  }
</script>